import React from 'react';
import LabelValue from 'components/ui/tailwind/label-value';
import CargomaticCard from 'components/v2/card';
import { sluggify } from 'utils/localization/utils';
import { withTranslation } from 'react-i18next';
import EditButton from '../../v2/buttons/EditButton';
import DeleteButton from '../../v2/buttons/DeleteButton';
const LocationPreview = (props) => {
    const { type, location, t } = props;
    const name = location ? location.name : null;
    const address = location ? location.address : null;
    return (React.createElement(CargomaticCard, { header: () => (React.createElement("div", { className: "flex items-center justify-between" },
            React.createElement("h3", { className: "my-0 text-xl font-medium" }, t('DEFAULT_TYPE', { type: t(sluggify(type)) })),
            React.createElement("div", { className: "flex items-center justify-end -mx-1" },
                React.createElement("div", { className: "px-1" },
                    React.createElement(EditButton, { onClick: () => props.onEdit(type) })),
                React.createElement("div", { className: "px-1" },
                    React.createElement(DeleteButton, { onClick: () => props.onRemove(type) }))))) },
        React.createElement("div", { className: "cursor-pointer", onClick: () => props.onEdit(type) },
            React.createElement(LabelValue, { value: `${name}`, icon: "home" }),
            React.createElement(LabelValue, { value: `${address}`, icon: "map-marker" }))));
};
export default withTranslation()(LocationPreview);
